/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ConsentFormAliases {
  CONSENT_FORM_CHECK_ACTION = 'consent-form-check-action',
  CONSENT_FORM_CONTEXTUAL_BAR = 'consent-form-contextual-bar',
  CONSENT_FORM_FETCH = 'consent-form-fetch',
  CONSENT_FORM_HTML_VIEWER = 'consent-form-html-viewer',
  CONSENT_FORM_LAYOUT = 'consent-form-layout',
  CONSENT_FORM_MAPPER = 'consent-form-mapper',
  CONSENT_FORM_PANEL = 'consent-form-panel',
  LAYOUT_CONTEXTUALBAR_CONTENT = 'layout-contextualbar-content',
  PANEL_CONSENT_ITEM_CONSENT_FORM = 'panel-consent-item-consent-form',
  REPEATER_CONSENT_ITEM_LIST_CONSENT_FORM = 'repeater-consent-item-list-consent-form',
  TOAST_NOTIFICATION = 'toast-notification',
}
export { ConsentFormAliases };
